module.exports = __webpack_public_path__ + "static/img/track_en_blue.ae4044b5.png";